/**
 * `emit` — fire-and-forget producer for the in-app analytics bus.
 *
 * Decoupled from PostHog by design: dispatches a `sossiety:analytics`
 * CustomEvent on `window`, which `analytics-bridge.ts` forwards to PostHog.
 * Callers stay provider-agnostic and unit tests can spy on `window` events
 * without mocking the SDK. Same shape as the in-line dispatcher in
 * `usePremiumTriggerAnalytics`.
 */

import { ANALYTICS_BUS_EVENT } from './events';

export function emit(name: string, properties?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(
      new CustomEvent(ANALYTICS_BUS_EVENT, { detail: { name, ...properties } }),
    );
    if (import.meta.env?.DEV) {
      console.debug('[analytics]', name, properties);
    }
  } catch {
    /* never throw from analytics */
  }
}
